export default __webpack_public_path__ + "static/thumb-landscape-e540a5025ee5b15a019d4463a5b53715.jpg";